<template>
    <div>
        <fieldset>
            <div class="row">
                <legend>RX Information</legend>
                <p v-if="sampleobject.programId == 'TROPP'" class="small-text"> Please note: Xtractive Polarized Gray is only available on Varilux Comfort DRx.<br></p>
            </div>
            <div class="row">
                <div class="columns small-12 medium-3 text-left lp">
                    <p class="small-text"> {{choices.lensDesignLabel}}:
                        <br>
                        <strong>{{ chosenDesign }}</strong>
                    </p>
                </div>
                <div v-if="chosenMaterial" class="columns small-12  medium-3  text-left lp">
                    <p class="small-text"> {{choices.lensMaterialLabel}}:
                        <br>
                        <strong>{{ chosenMaterial }}</strong>
                    </p>
                </div>
                <div v-if="chosenPhotochromic" class="columns small-12  medium-3  text-left lp end">
                    <p class="small-text"> {{choices.lensPhotochromicLabel}}:
                        <br>
                        <strong>{{ chosenPhotochromic }}</strong>
                    </p>
                </div>
                <div v-if="chosenTreatment" class="columns small-12  medium-3  text-left lp">
                    <p class="small-text">{{choices.lensTreatmentLabel}}:
                        <br>
                        <strong>{{ chosenTreatment }}</strong>
                    </p>
                </div>
            </div>
            <div class="row" v-if="choices.design.length > 1">
                <div class="small-12 medium-6 columns lp end">
                    <div :class="{'error': errors.has(choices.lensDesignLabel) }">
                        <label for="designID">{{choices.lensDesignLabel}}: *</label>
                        <select id='designId' v-validate data-vv-rules="required" class="orderinput-select" @change="handleDesignChange" :name="choices.lensDesignLabel" v-model="sampleobject.design">
                            <!--<option selected value> </option>-->
                            <option v-for="c in choices.design" :value="c.value" :key="c.value">{{c.label}}</option>
                        </select>
                        <p class="error" v-if="errors.has(choices.lensDesignLabel)">{{ errors.first(choices.lensDesignLabel) }}</p>
                    </div>
                </div>
            </div>
            <div class="row" v-if="choices.material.length >= 1">
                <div class="small-12 medium-6 columns lp end">
                    <div :class="{'error': errors.has(choices.lensMaterialLabel) }">
                        <label for="materialId">{{choices.lensMaterialLabel}}: *</label>
                        <select id='materialId' v-validate data-vv-rules="required" class="orderinput-select" @change="handleMaterialChange" :disabled="disableMaterial" :name="choices.lensMaterialLabel" v-model="sampleobject.material">
                            <!--<option selected value> </option>-->
                            <option v-for="c in choices.material" :value="c.value" :key="c.value">{{c.label}}</option>
                        </select>
                        <p class="error" v-if="errors.has(choices.lensMaterialLabel)">{{ errors.first(choices.lensMaterialLabel) }}</p>
                    </div>
                </div>
            </div>
            <div class="row" v-if="choices.photochromic.length >= 1">
                <div class="small-12 medium-6 columns lp end">
                    <div :class="{'error': errors.has(choices.lensPhotochromicLabel) }">
                        <label for="photochromicId">{{choices.lensPhotochromicLabel}}: *</label>
                        <select id='photochromicId' v-validate data-vv-rules="required" class="orderinput-select" @change="handlePhotochromicChange" :disabled="disablePhotochromic" :name="choices.lensPhotochromicLabel" v-model="sampleobject.photochromic">
                            <!--<option selected value> </option>-->
                            <!--TODO: Create a method to handle the disability for multiple Evaluation Product programs in the future.
                                Feature: Disabled the XTRActive Polarized Gray option when the design is Varilux X Design. 
                                -->
                            <option 
                                :disabled="chosenDesign == 'Varilux X Design' && c.value == 'XTRP-GRY0-00' && sampleobject.programId == 'TROPP'" 
                                v-for="c in choices.photochromic" :value="c.value" :key="c.value">
                                    {{c.label}}
                            </option>
                        </select>
                        <p class="error" v-if="errors.has(choices.lensPhotochromicLabel)">{{ errors.first(choices.lensPhotochromicLabel) }}</p>
                    </div>
                </div>
            </div>
            <div class="row" v-if="choices.treatment.length > 1">
                <div class="small-12 medium-6 columns lp end">
                    <div :class="{'error': errors.has(choices.lensTreatmentLabel) }">
                        <label for="treatmentID">{{choices.lensTreatmentLabel}}: *</label>
                        <select id='treatmentId' v-validate data-vv-rules="required" class="orderinput-select" :disabled="disableTreatment" :name="choices.lensTreatmentLabel" v-model="sampleobject.treatment">
                            <!--<option selected value> </option>-->
                            <option v-for="c in choices.treatment" :value="c.value" :key="c.value">{{c.label}}</option>
                        </select>
                        <p class="error" v-if="errors.has(choices.lensTreatmentLabel)">{{ errors.first(choices.lensTreatmentLabel) }}</p>
                    </div>
                </div>
            </div>
          <div class="row small-collapse">
            <p class="small-text"> Note: Most prescriptions will not have base and prism.<br></p>
                <div class="small-12 medium-4 columns">
                    <table class="rxinfo-table">
                        <thead class="rxinfo-thead">
                            <tr>
                                <th class="rxinfo-TableInputBox rxinfo-leading-col"></th>
                                <th>Sph. *</th>
                                <th>Cyl.</th>
                                <th>Axi.</th>
                                <th v-if="sampleobject.isProgressive">Add.
                                    <span class="rxinfo-asterik" v-if="sampleobject.isProgressive">*</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="rxinfo-TableInputBox rxinfo-leading-col">R</td>
                                <td class="rxinfo-TableInputBox">
                                    <div :class="{'error': errors.has('right sphere') }">
                                        <rx-field :useSign="true" :required="true" :min="-12" :max="9" :precision="2" type="text" name="right sphere" v-model='sampleobject.resph'></rx-field>
                                    </div>
                                </td>
                                <td class="rxinfo-TableInputBox">
                                    <div :class="{'error': errors.has('right cylinder') }">
                                        <rx-field :useSign="true" :required="reCylRequired" :min="-6" :max="6" :precision="2" type="text" name="right cylinder" v-model='sampleobject.recyl'></rx-field>
                                    </div>
                                </td>
                                <td class="rxinfo-TableInputBox">
                                    <div :class="{'error': errors.has('right axis') }">
                                        <rx-field :required="reAxisRequired" :min="0" :max="180" :precision="0" type="text" name="right axis" v-model='sampleobject.reaxis'></rx-field>
                                    </div>
                                </td>
                                <td class="rxinfo-TableInputBox" v-if="sampleobject.isProgressive">
                                    <div :class="{'error': errors.has('right add') }">
                                        <rx-field :useSign="true" :required="sampleobject.isProgressive" :min="0" :max="4" :precision="2" type="text" name="right add" v-model='sampleobject.readd'></rx-field>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="rxinfo-TableInputBox rxinfo-leading-col">L</td>
                                <td class="rxinfo-TableInputBox">
                                    <div :class="{'error': errors.has('left sphere') }">
                                        <rx-field :useSign="true" :required="true" :min="-12" :max="9" :precision="2" type="text" name="left sphere" v-model='sampleobject.lesph'></rx-field>
                                    </div>
                                </td>
                                <td class="rxinfo-TableInputBox">
                                    <div :class="{'error': errors.has('left cylinder') }">
                                        <rx-field :useSign="true" :required="leCylRequired" :min="-6" :max="6" :precision="2" type="text" name="left cylinder" v-model='sampleobject.lecyl'></rx-field>
                                    </div>
                                </td>
                                <td class="rxinfo-TableInputBox">
                                    <div :class="{'error': errors.has('left axis') }">
                                        <rx-field :required="leAxisRequired" :min="0" :max="180" :precision="0" type="text" name="left axis" v-model='sampleobject.leaxis'></rx-field>
                                    </div>
                                </td>
                                <td class="rxinfo-TableInputBox" v-if="sampleobject.isProgressive">
                                    <div :class="{'error': errors.has('left add') }">
                                        <rx-field :useSign="true" :required="sampleobject.isProgressive" :min="0" :max="4" :precision="2" type="text" name="left add" v-model='sampleobject.leadd'></rx-field>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="small-12 medium-5 columns">
                    <table class="rxinfo-table">
                        <thead class="rxinfo-thead">
                            <tr>
                                <th class="show-for-small-only rxinfo-leading-col"></th>
                                <th>H. Prism</th>
                                <th>H. Base</th>
                                <th>V. Prism</th>
                                <th>V. Base</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="show-for-small-only rxinfo-leading-col">R</td>
                                <td class="rxinfo-TableInputBox25">
                                    <div :class="{'error': errors.has('right h prism') }">
                                        <rx-field :required="reHPrismRequired" :min="0" :max="99.75" :precision="2" input type="text" name="right h prism" v-model='sampleobject.rehorizPrismValue'></rx-field>
                                    </div>
                                </td>
                                <td class="rxinfo-TableInputBox25">
                                    <div>
                                        <select :style="{'border-color': errors.has('right h prism direction') ? 'red' : '' }" v-validate="reHPrismDirectionRequired" class="rxinfo-select" name="right h prism direction" v-model="sampleobject.rehorizPrismDirection">
                                            <option selected value> </option>
                                            <option value="000">IN</option>
                                            <option value="180">OUT</option>
                                        </select>
                                    </div>
                                </td>
                                <td class="rxinfo-TableInputBox25">
                                    <div :class="{'error': errors.has('right v prism') }">
                                        <rx-field :required="reVPrismRequired" :min="0" :max="99.75" :precision="2" input type="text" name="right v prism" v-model='sampleobject.reverticalPrismValue'></rx-field>
                                    </div>
                                </td>
                                <td class="rxinfo-TableInputBox25">
                                    <div :class="{'error': errors.has('right v prism direction') }">
                                        <select :style="{'border-color': errors.has('right v prism direction') ? 'red' : '' }" v-validate="reVPrismDirectionRequired" class="rxinfo-select" name="right v prism direction" v-model="sampleobject.reverticalPrismDirection">
                                            <option selected value> </option>
                                            <option value="090">UP</option>
                                            <option value="270">DOWN</option>
                                        </select>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="show-for-small-only rxinfo-leading-col">L</td>
                                <td class="rxinfo-TableInputBox">
                                    <div :class="{'error': errors.has('left h prism') }">
                                        <rx-field :required="leHPrismRequired" :min="0" :max="99.75" :precision="2" input type="text" name="left h prism" v-model='sampleobject.lehorizPrismValue'></rx-field>
                                    </div>
                                </td>
                                <td class="rxinfo-TableInputBox">
                                    <div :class="{'error': errors.has('left h prism direction') }">
                                        <select :style="{'border-color': errors.has('left h prism direction') ? 'red' : '' }" v-validate="leHPrismDirectionRequired" class="rxinfo-select" name="left h prism direction" v-model="sampleobject.lehorizPrismDirection">
                                            <option selected value> </option>
                                            <option value="180">IN</option>
                                            <option value="000">OUT</option>
                                        </select>
                                    </div>
                                </td>
                                <td class="rxinfo-TableInputBox">
                                    <div :class="{'error': errors.has('left v prism') }">
                                        <rx-field :required="leVPrismRequired" :min="0" :max="99.75" :precision="2" input type="text" name="left v prism" v-model='sampleobject.leverticalPrismValue'></rx-field>
                                    </div>
                                </td>
                                <td class="rxinfo-TableInputBox">
                                    <div :class="{'error': errors.has('left b prism direction') }">
                                        <select :style="{'border-color': errors.has('left v prism direction') ? 'red' : '' }" v-validate="leVPrismDirectionRequired" class="rxinfo-select" name="left v prism direction" v-model="sampleobject.leverticalPrismDirection">
                                            <option selected value> </option>
                                            <option value="090">UP</option>
                                            <option value="270">DOWN</option>
                                        </select>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="small-12 medium-3 columns end">
                    <table class="rxinfo-table">
                        <thead class="rxinfo-thead">
                            <tr>
                                <th class="show-for-small-only"></th>
                                <th>Dist PD *</th>
                                <th>Eye Height *</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="show-for-small-only  rxinfo-leading-col">R</td>
                                <td class="rxinfo-TableInputBox">
                                    <div :class="{'error': errors.has('right distance PD') }">
                                        <rx-field :required="true" :precision="1" :min="20.00" :max="39.9" type="text" name="right distance PD" v-model='sampleobject.redistPD'></rx-field>
                                    </div>
                                </td>
                                <td class="rxinfo-TableInputBox">
                                    <div :class="{'error': errors.has('right eyeheight') }">
                                        <rx-field :required="true" :precision="2" :min="14" :max="40" type="text" name="right eyeheight" v-model='sampleobject.resegHeight'></rx-field>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="show-for-small-only rxinfo-leading-col">L</td>
                                <td class="rxinfo-TableInputBox">
                                    <div :class="{'error': errors.has('left distance PD') }">
                                        <rx-field :required="true" :precision="1" :min="20" :max="39.9" type="text" name="left distance PD" v-model='sampleobject.ledistPD'></rx-field>
                                    </div>
                                </td>
                                <td class="rxinfo-TableInputBox">
                                    <div :class="{'error': errors.has('left eyeheight') }">
                                        <rx-field :required="true" :precision="2" :min="14" :max="40" type="text" name="left eyeheight" v-model='sampleobject.lesegHeight'></rx-field>
                                    </div>
                                </td>
                             </tr>
                        </tbody>
                    </table>
                </div>
                <div class="columns small-12">
                    <v-popover
                        :auto-hide="false"
                        >
                        <button class="tooltip-target b3" type="button" v-tooltip.top-center><p class="small-text text-blue link" style="text-decoration: underline;">What are PD and fitting height?</p></button>
                        <template slot="popover">
                            <div class="download-image">
                                <a class="small-text" @click="downloadImage('/images/PDandEyeHeightImage.png')"> Download </a>
                                <a v-close-popover class="small-text"> <span class="icon-cross"></span></a>
                            </div>
                            <img src="/images/PDandEyeHeightImage.png" >
                        </template>
                    </v-popover>
                    <!--<p class="small-text text-blue">
                        Frame measurements are available on the catalog.
                    </p>-->
                    <div class="error">
                        <p class="error" v-if="errors.has('right sphere')">{{ errors.first('right sphere') }}</p>
                        <p class="error" v-if="errors.has('right cylinder')">{{ errors.first('right cylinder') }}</p>
                        <p class="error" v-if="errors.has('right axis')">{{ errors.first('right axis') }}</p>
                        <p class="error" v-if="errors.has('right add')">{{ errors.first('right add') }}</p>
                        <p class="error" v-if="errors.has('left sphere')">{{ errors.first('left sphere') }}</p>
                        <p class="error" v-if="errors.has('left cylinder')">{{ errors.first('left cylinder') }}</p>
                        <p class="error" v-if="errors.has('left axis')">{{ errors.first('left axis') }}</p>
                        <p class="error" v-if="errors.has('left add')">{{ errors.first('left add') }}</p>
                    </div>
                    <div class="error">
                        <p class="error" v-if="errors.has('right h prism')">{{ errors.first('right h prism') }}</p>
                        <p class="error" v-if="errors.has('right h prism direction')">{{ errors.first('right h prism direction') }}</p>
                        <p class="error" v-if="errors.has('right v prism')">{{ errors.first('right v prism') }}</p>
                        <p class="error" v-if="errors.has('right v prism direction')">{{ errors.first('right v prism direction') }}</p>
                        <p class="error" v-if="errors.has('left h prism')">{{ errors.first('left h prism') }}</p>
                        <p class="error" v-if="errors.has('left h prism direction')">{{ errors.first('left h prism direction') }}</p>
                        <p class="error" v-if="errors.has('left v prism')">{{ errors.first('left v prism') }}</p>
                        <p class="error" v-if="errors.has('left v prism direction')">{{ errors.first('left v prism direction') }}</p>
                    </div>
                    <div class="error">
                        <p class="error" v-if="errors.has('right distance PD')">{{ errors.first('right distance PD') }}</p>
                        <p class="error" v-if="errors.has('right eyeheight')">{{ errors.first('right eyeheight') }}</p>
                        <p class="error" v-if="errors.has('left distance PD')">{{ errors.first('left distance PD') }}</p>
                        <p class="error" v-if="errors.has('left eyeheight')">{{ errors.first('left eyeheight') }}</p>
                    </div>
                </div>
                <div v-if="showTrackInput" class="small-12 columns end">
                    <div class="medium-4 columns lp">
                        <div :class="{'error': !hasInvalidNVBValue }">
                        <labeled-input
                            validation="required|alpha_num|min:7|max:7"
                            @input="formatNVB"
                            label="NVB *"
                            name="NVB"
                            v-model="sampleobject.NVB"
                        ></labeled-input>
                        <p class="error" v-if="!hasInvalidNVBValue">Invalid NVB value</p>
                        </div>
                    </div>
                </div>
                <div v-if="showStylisticInput" class="small-12 columns end">
                    <div class="medium-4 columns lp">
                        <label for="wrapAngle">Wrap Angle *</label>
                        <div :class="{'error': errors.has('Wrap') }">
                            <rx-field :decimalEnabled="false" :required="true" :min="0" :max="25" type="text" name="Wrap" id="wrapAngle" v-model='sampleobject.WrapAngle' v-tooltip.hover title="Must be between 0 and 25"></rx-field>
                        </div>
                        <p class="small-text text-blue">Must be between 0 and 25</p>
                    </div>
                    <div class="medium-4 columns mp">
                        <label for="sPBaseCurve">Base Curve *</label>
                        <div :class="{'error': errors.has('BaseCurve') }">
                            <rx-field :required="true" :precision="2" :min="4.25" :max="8.5" :decimalEnabled="true" type="text" name="BaseCurve" v-model='sampleobject.SPBaseCurve' v-tooltip.hover title="Must be between 4.25 and 8.5"></rx-field>
                        </div>
                        <p class="small-text text-blue">Must be between 4.25 and 8.5</p>
                    </div>
                    <div class="medium-4 columns rp">
                        <label for="pantoAngle">Panto</label>
                        <div :class="{'error': errors.has('Panto') }">
                            <rx-field :useSign="true" :required="false" :min="-5" :max="25" type="text" :decimalEnabled="false" name="Panto" v-model='sampleobject.PantoAngle' v-tooltip.hover title="Must be between -5 and 25"></rx-field>
                        </div>
                        <p class="small-text text-blue">Must be between -5 and 25</p>
                    </div>
                </div>
                <div v-if="showStylisticInput" class="small-12 columns end">
                    <div class="medium-6 columns lp">
                        <label for="rightVertexDistance">Vertex Distance RE</label>
                        <div :class="{'error': errors.has('RightVertexDistance') }">
                            <rx-field :required="false" :min="5" :max="22" type="text" :decimalEnabled="false" name="RightVertexDistance" v-model='sampleobject.RightVertexDistance' v-tooltip.hover title="Must be between 5 and 22"></rx-field>
                        </div>
                        <p class="small-text text-blue">Must be between 5 and 22</p>
                    </div>
                    <div class="medium-6 columns rp">
                        <label for="leftVertexDistance">Vertex Distance LE</label>
                        <div :class="{'error': errors.has('LeftVertexDistance') }">
                            <rx-field :required="false" :min="5" :max="22" type="text" :decimalEnabled="false" name="LeftVertexDistance" v-model='sampleobject.LeftVertexDistance' v-tooltip.hover title="Must be between 5 and 22"></rx-field>
                        </div>
                        <p class="small-text text-blue">Must be between 5 and 22</p>
                    </div>
                </div>
                <div v-if="showTrackInput" class="small-12 columns end">
                    <div class="medium-4 columns lp">
                        <label for="wrapAngle">Wrap Angle *</label>
                        <div :class="{'error': errors.has('Wrap') }">
                            <rx-field :decimalEnabled="false" :required="true" :min="0" :max="25" type="text" name="Wrap" id="wrapAngle" v-model='sampleobject.WrapAngle' v-tooltip.hover title="Must be between 0 and 25"></rx-field>
                        </div>
                        <p class="small-text text-blue">Must be between 0 and 25</p>
                    </div>
                    <div class="medium-4 columns mp">
                        <labeled-input
                            validation="alpha_num"
                            label="Initials"
                            name="Initials"
                            v-model="sampleobject.Initials"
                        ></labeled-input>
                    </div>
                    <div class="medium-4 columns rp">
                        <label for="pantoAngle">Panto *</label>
                        <div :class="{'error': errors.has('Panto') }">
                            <rx-field :useSign="true" :required="true" :min="-5" :max="25" type="text" :decimalEnabled="false" name="Panto" v-model='sampleobject.PantoAngle' v-tooltip.hover title="Must be between -5 and 25"></rx-field>
                        </div>
                        <p class="small-text text-blue">Must be between -5 and 25</p>
                    </div>
                </div>
                <div v-if="showTrackInput" class="small-12 columns end">
                    <div class="medium-6 columns lp">
                        <label for="rightVertexDistance">Vertex Distance RE *</label>
                        <div :class="{'error': errors.has('RightVertexDistance') }">
                            <rx-field :required="true" :min="5" :max="22" type="text" :decimalEnabled="false" name="RightVertexDistance" v-model='sampleobject.RightVertexDistance' v-tooltip.hover title="Must be between 5 and 22"></rx-field>
                        </div>
                        <p class="small-text text-blue">Must be between 5 and 22</p>
                    </div>
                    <div class="medium-6 columns rp">
                        <label for="leftVertexDistance">Vertex Distance LE *</label>
                        <div :class="{'error': errors.has('LeftVertexDistance') }">
                            <rx-field :required="true" :min="5" :max="22" type="text" :decimalEnabled="false" name="LeftVertexDistance" v-model='sampleobject.LeftVertexDistance' v-tooltip.hover title="Must be between 5 and 22"></rx-field>
                        </div>
                        <p class="small-text text-blue">Must be between 5 and 22</p>
                    </div>
                </div>
                <div v-if="!showTrackInput" class="small-12 columns end">
                    <div class="medium-4 columns lp">
                        <label for="wrapAngle">Wrap Angle</label>
                        <div :class="{'error': errors.has('Wrap') }">
                            <rx-field :decimalEnabled="false" :min="0" :max="25" type="text" name="Wrap" id="wrapAngle" v-model='sampleobject.WrapAngle' v-tooltip.hover title="Must be between 0 and 25"></rx-field>
                        </div>
                        <p class="small-text text-blue">Must be between 0 and 25</p>
                    </div>
                    <div class="medium-4 columns lp">
                        <label for="pantoAngle">Panto</label>
                        <div :class="{'error': errors.has('Panto') }">
                            <rx-field :useSign="true" :min="-5" :max="25" type="text" :decimalEnabled="false" name="Panto" v-model='sampleobject.PantoAngle' v-tooltip.hover title="Must be between -5 and 25"></rx-field>
                        </div>
                        <p class="small-text text-blue">Must be between -5 and 25</p>
                    </div>
                    <div class="medium-4 columns lp">
                    </div>
                </div>
                <div v-if="!showTrackInput" class="small-12 columns end">
                    <div class="medium-6 columns lp">
                        <label for="rightVertexDistance">Vertex Distance RE</label>
                        <div :class="{'error': errors.has('RightVertexDistance') }">
                            <rx-field :min="5" :max="22" type="text" :decimalEnabled="false" name="RightVertexDistance" v-model='sampleobject.RightVertexDistance' v-tooltip.hover title="Must be between 5 and 22"></rx-field>
                        </div>
                        <p class="small-text text-blue">Must be between 5 and 22</p>
                    </div>
                    <div class="medium-6 columns lp">
                        <label for="leftVertexDistance">Vertex Distance LE</label>
                        <div :class="{'error': errors.has('LeftVertexDistance') }">
                            <rx-field :min="5" :max="22" type="text" :decimalEnabled="false" name="LeftVertexDistance" v-model='sampleobject.LeftVertexDistance' v-tooltip.hover title="Must be between 5 and 22"></rx-field>
                        </div>
                        <p class="small-text text-blue">Must be between 5 and 22</p>
                    </div>
                </div>
            </div>
        </fieldset> 
    </div>
</template>

<script>
function getChoice(choices, choice) {
    if (choices == null)  return '';
    if (choices.length == 1) {
        return choices[0].label;
    }
    for (let d of choices) {
        if (d.value === choice) {
            return d.label;
        }
    }

    return '';
}


function getChoiceValue(choices, choice) {
  if (choices == null)  return '';

  if (choices.length == 1) {
    return choices[0].value;
  }
  for (let d of choices) {
    if (d.value === choice) {
      return d.value;
    }
  }

  return null;
}

import RxField from "@/components/order/RxField";
import LabeledInput from "@/components/shared/LabeledInput";

export default {
  props: ["selected", "sampleobject", "choices", "programChoice"],
  components: { RxField, LabeledInput },
  inject: ["$validator"],
  data() {
    return {
        hasInvalidNVBValue: true,
        disableMaterial: true,
        disablePhotochromic: true,
        disableTreatment: true,
        programId: null
    };
  },
  
  computed: {
    chosenDesign() {
      return getChoice(this.choices.design, this.sampleobject.design);
    },
    chosenMaterial() {
      return getChoice(this.choices.material, this.sampleobject.material);
    },
    chosenTreatment() {
      return getChoice(this.choices.treatment, this.sampleobject.treatment);
    },
    chosenPhotochromic() {
      return getChoice(this.choices.photochromic, this.sampleobject.photochromic);
    },
    reCylRequired() {
      return this.sampleobject.reaxis != null;
    },
    leCylRequired() {
      return this.sampleobject.leaxis != null;
    },
    reAxisRequired() {
      return this.sampleobject.recyl != null;
    },
    leAxisRequired() {
      return this.sampleobject.lecyl != null;
    },
    reHPrismRequired() {
      return (
        this.sampleobject.rehorizPrismDirection != null &&
        this.sampleobject.rehorizPrismDirection.trim() != ""
      );
    },
    reHPrismDirectionRequired() {
      return this.sampleobject.rehorizPrismValue != null ? "required" : "";
    },
    reVPrismRequired() {
      return (
        this.sampleobject.reverticalPrismDirection != null &&
        this.sampleobject.reverticalPrismDirection.trim() != ""
      );
    },
    reVPrismDirectionRequired() {
      return this.sampleobject.reverticalPrismValue != null ? "required" : "";
    },
    leHPrismRequired() {
      return (
        this.sampleobject.lehorizPrismDirection != null &&
        this.sampleobject.lehorizPrismDirection.trim() != ""
      );
    },
    leHPrismDirectionRequired() {
      return this.sampleobject.lehorizPrismValue != null ? "required" : "";
    },
    leVPrismRequired() {
      return (
        this.sampleobject.leverticalPrismDirection != null &&
        this.sampleobject.leverticalPrismDirection.trim() != ""
      );
    },
    leVPrismDirectionRequired() {
      return this.sampleobject.leverticalPrismValue != null ? "required" : "";
    },
    showTrackInput() {
      return (
        this.sampleobject.design === 'VXXRTRACK' ||
        this.sampleobject.design === 'VXPHYEXTTRACK'
      );
    },
    showStylisticInput() {
      return (
        this.sampleobject.design === 'STYLISTICW'
      );
    },
    getProgramId() {
      return this.sampleobject.couponCode.substring(0, 5);
    }
  },
  mounted() {
    this.sampleobject.design = getChoiceValue(this.choices.design, this.sampleobject.design);
    this.sampleobject.treatment = getChoiceValue(this.choices.treatment, this.sampleobject.treatment);
    this.sampleobject.material = getChoiceValue(this.choices.material, this.sampleobject.material);
    this.sampleobject.photochromic = getChoiceValue(this.choices.photochromic, this.sampleobject.photochromic);
    this.isNVBValid();
    this.handleDisabling();
  },
  methods: {
    async downloadImage(url) {
        //console.log(window.location)
        axios({
            url: window.location.origin + url,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', 'PDandEyeHeightImage.png');
            document.body.appendChild(fileLink);

            fileLink.click();
        });
    },
    isNVBValid() {
        const restrictedLetters = ['o', 'i', 'u', '0'];
        if (this.sampleobject.NVB) {
            const nvbLowerCase = this.sampleobject.NVB.toLowerCase();
            this.hasInvalidNVBValue = !restrictedLetters.some(letter => nvbLowerCase.includes(letter));
            this.$emit('hasInvalidNVBValue', !this.hasInvalidNVBValue); 
        } else {
            this.hasInvalidNVBValue = true;
        }
    },
    formatNVB() {
      // Convert the value to uppercase
      this.sampleobject.NVB = this.sampleobject.NVB.toUpperCase();
      // Trigger validation if needed
      this.isNVBValid();
    },
    async getProgramService() {
      try {
        const response = await axios.get('/order/GetProgram', {
            params: {
                couponCode: this.sampleobject.couponCode,
                programType: this.sampleobject.programType,
                lensProgramId: this.sampleobject.programId ? this.sampleobject.programId : this.getProgramId,
                programId: this.sampleobject.programId ? this.sampleobject.programId : this.getProgramId,
                design: this.sampleobject.design,
                material: this.sampleobject.material,
                photochromic: this.sampleobject.photochromic,
            },
        });
        this.choices.material = this.filterResponse(response.data.MaterialChoices);
        this.choices.design = this.filterResponse(response.data.DesignChoices);
        this.choices.photochromic = this.filterResponse(response.data.PhotochromicChoices);
        this.choices.treatment = this.filterResponse(response.data.TreatmentChoices);
      } catch (error) {
        console.error('Error calling GetProgram service:', error);
        // Handle the error here
      }
    },
    async handleDesignChange() {
      if (this.choices.treatment.length > 1 && this.choices.treatment.length > 1 || this.choices.photochromic.length > 1) {
        this.resetAndDisable(['material', 'photochromic', 'treatment']);
    }
      this.sampleobject.photochromic = getChoiceValue(this.choices.photochromic, this.sampleobject.photochromic);
      this.sampleobject.treatment = getChoiceValue(this.choices.treatment, this.sampleobject.treatment);
      this.sampleobject.material = getChoiceValue(this.choices.material, this.sampleobject.material);
      await this.getProgramService();
      this.disableMaterial = !this.chosenDesign;
      this.disablePhotochromic = !this.chosenMaterial;
      this.disableTreatment = !this.chosenPhotochromic;
      if (this.sampleobject.design && this.sampleobject.material && this.sampleobject.photochromic === null) {
        this.disableTreatment = false;
      }
      if (this.sampleobject.design && this.choices.material.length === 1) {
        this.handleMaterialChange();
      }
    },
    async handleMaterialChange() {
        if (this.choices.treatment.length > 1 && this.choices.photochromic.length > 1) {
            this.resetAndDisable(['photochromic', 'treatment']);
        }
        this.sampleobject.photochromic = getChoiceValue(this.choices.photochromic, this.chosenPhotochromic);
        this.sampleobject.material = getChoiceValue(this.choices.material, this.sampleobject.material);
        //console.log("data: ", this.sampleobject.material);
        await this.getProgramService();
        this.disablePhotochromic = !this.chosenMaterial;
        this.disableTreatment = !this.chosenPhotochromic;
    },
    async handlePhotochromicChange() {
        if (this.choices.treatment.length > 1) {
            this.resetAndDisable(['treatment']);
        }
        await this.getProgramService();
        this.disableTreatment = !this.chosenPhotochromic;
    },
    resetAndDisable(fields) {
        fields.forEach(field => this.sampleobject[field] = null);
        this.disableFields(fields);
    },
    disableFields(fields) {
        fields.forEach(field => this[`disable${field.charAt(0).toUpperCase() + field.slice(1)}`] = true);
    },
    handleDisabling() {
        this.disableMaterial = !this.chosenDesign;
        this.disablePhotochromic = !this.chosenMaterial;
        this.disableTreatment = !this.chosenPhotochromic;
    },
    filterResponse(response) {
        return response.map(item => { return {label: item.Label, value: item.Value}});
    },
    validateMinMax() {
      const min = 4.25;
      const max = 8.5;
      const value = parseFloat(this.sampleobject.SPBaseCurve);
      
      if (isNaN(value)) {
        this.errors.add('BaseCurve');
        return;
      }

      if (value < min || value > max) {
        this.errors.add('BaseCurve');
      } else {
        this.errors.delete('BaseCurve');
      }
    }
 }
};
</script>

<style>
table tbody tr:nth-child(even) {
  background-color: #fff;
}

.rxinfo-select {
  font-size: 11pt;
  display: table-cell;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0 20px 0 5px;
}

.rxinfo-thead {
  background-color: ghostwhite;
}

.rxinfo-TableInputBox {
  margin: 0;
  padding: 0;
}

.rxinfo-TableInputBox25 {
  margin: 0;
  padding: 0;
  width: 25%;
}

.rxinfo-table input:focus,
.rxinfo-table select:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.rxinfo-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 8pt;
  font-style: normal;
}

.rxinfo-smallpad {
  padding-bottom: 10px;
}

.rxinfo-table tr,
.rxinfo-table th {
  border: 1px solid #cacaca;
  border-collapse: collapse;
}

.rxinfo-table td {
  border: 1px solid #cacaca;
}

.rxinfo-asterik {
  font-size: 8pt;
  font-style: normal;
}

.rxinfo-TableInputBox div {
  margin: auto;
  padding: 0;
  height: 100%;
  width: 100%;
}

.rxinfo-leading-col {
  width: 25px;
  text-align: center;
}

.tooltip {
  display: block !important;
  z-index: 1;
  cursor: pointer;
}
.tooltip .tooltip-inner {
    background: white;
    color: white;
    border-radius: 16px;
    /* padding: 5px 10px 4px; */
    width: 750px;
}

.tooltip .tooltip-arrow {
    width: 0;
    height: 0;
    /* border-style: solid; */
    position: absolute;
    margin: 5px;
    border-color: white;
}

.tooltip[x-placement^="top"] {
    margin-bottom: 5px;
}

.tooltip[x-placement^="top"]  .tooltip-arrow {
    border-width: 5px 5px 0 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    bottom: -5px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
}
  
.tooltip[x-placement^="bottom"] {
    margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
    border-width: 0 5px 5px 5px;
    border-left-color: transparent !important;
    border-right-color: transparent !important;
    border-top-color: transparent !important;
    top: -5px;
    left: calc(50% - 5px);
    margin-top: 0;
    margin-bottom: 0;
}
  

.tooltip[x-placement^="right"] {
    margin-left: 5px; 
}

.tooltip[x-placement^="right"] .tooltip-arrow {
    border-width: 5px 5px 5px 0;
    border-left-color: transparent !important;
    border-top-color: transparent !important;
    border-bottom-color: transparent !important;
    left: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
}
  
.tooltip[x-placement^="left"] {
    margin-right: 5px;
}
.tooltip[x-placement^="left"] .tooltip-arrow {
    border-width: 5px 0 5px 5px;
    border-top-color: transparent !important;
    border-right-color: transparent !important;
    border-bottom-color: transparent !important;
    right: -5px;
    top: calc(50% - 5px);
    margin-left: 0;
    margin-right: 0;
}
  
.tooltip[aria-hidden='true'] {
    visibility: hidden;
    opacity: 0;
    transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
    visibility: visible;
    opacity: 1;
    transition: opacity .15s;
}
.tooltip {
    padding: 0 .75rem;
    max-width: 210px;
}
.tooltip.popover {
    color: #f9f9f9;
    /* width: 100%; */
    background: white !important;
}
.tooltip .popover-inner {
    background: #f5eeff;
    color: black;
    border: #753bbd 2px solid;
    width: 750px;
    padding: 24px;
    border-radius: 5px;
    margin-left: 1px;
}

.tooltip.popover .popover-arrow {
    border-color: white !important;
}
  
.tooltip::before {
    display: unset;
    width: 0;
    height: 0;
    content: unset;
}

.text-blue {
    color: #00f;
}

.text-blue.link {
    cursor: pointer;
}

.close {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
}

.download-image {
    display: flex;
    justify-content: space-between;
}

.orderinput-select {
  border: 1px solid #ccc; /* You can adjust the color and thickness as needed */
  padding: 0 20px 0 10px
  
}
</style>
